import { createClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL || "https://uutmkipcocodzkmglejm.supabase.co";
const key = import.meta.env.VITE_SUPABASE_ANON_KEY || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InV1dG1raXBjb2NvZHprbWdsZWptIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzUyMzQxMDksImV4cCI6MjA5MDgxMDEwOX0.lWzi9phm3L1d9vvzpoUNE_j9OpBUMDCBYqe7AAIGBGM";

export const supabase = createClient(url, key, {
  auth: {
    autoRefreshToken: true,
    detectSessionInUrl: false,
    flowType: "implicit",
    persistSession: true,
    storageKey: "balmer-auth-session"
  }
});

let restoration: Promise<import("@supabase/supabase-js").Session | null> | undefined;
export function restoreOAuthSession() {
  if (restoration) return restoration;
  restoration = (async () => {
    sessionStorage.removeItem("balmer-oauth-access");
    sessionStorage.removeItem("balmer-oauth-refresh");
    const hash = new URLSearchParams(window.location.hash.slice(1));
    if (hash.has("error_description")) throw new Error(hash.get("error_description")!);
    const access_token = hash.get("access_token");
    const refresh_token = hash.get("refresh_token");
    if (!access_token || !refresh_token) return null;
    const { data, error } = await supabase.auth.setSession({ access_token, refresh_token });
    if (error) throw error;
    window.history.replaceState({}, document.title, window.location.pathname + window.location.search);
    return data.session;
  })();
  return restoration;
}
